import { render, staticRenderFns } from "./selectionOfOrganization.vue?vue&type=template&id=304c4381&scoped=true&"
import script from "./selectionOfOrganization.vue?vue&type=script&lang=js&"
export * from "./selectionOfOrganization.vue?vue&type=script&lang=js&"
import style0 from "./selectionOfOrganization.vue?vue&type=style&index=0&id=304c4381&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304c4381",
  null
  
)

export default component.exports